class SkipServiceModal {
    public elements = {
        skipServiceModalConfirmBtn: () => cy.get("#skip_service_modal_confirm_button"),
        commentInput: () => cy.get("#comment"),
    };
}

export default new SkipServiceModal();